"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditCycleCountHistory = void 0;
const filter_header_1 = require("client/components/filter-header");
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const select_1 = require("client/components/material/select");
const store_1 = require("client/modules/sites/modules/sites-list/store");
const store_2 = require("client/modules/stocks/store");
const store_3 = require("client/modules/users/store");
const material_ui_1 = require("material-ui");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
const capitalize_string_1 = require("shared/util/capitalize-string");
const throttle_debounce_1 = require("throttle-debounce");
const edit_cycle_count_history_detail_1 = require("./components/edit-cycle-count-history-detail");
require("./edit-cycle-count-history.less");
const moment = require("moment");
const columns = [
    {
        label: "site",
        id: "site"
    },
    {
        label: "user",
        id: "user"
    },
    {
        label: "createdAt",
        id: "createdAt"
    }
];
let EditCycleCountHistory = class EditCycleCountHistory extends react_1.Component {
    constructor() {
        super(...arguments);
        this.cycleCounts = [];
        this.siteId = 0;
        this.filterText = "";
        this.order = "DESC";
        this.orderBy = "id";
        this.cycleCountSelected = null;
        this.loadPurchaseCycleCounts = throttle_debounce_1.debounce(200, async () => {
            await store_2.stocksStore.loadCycleCounts({
                count: 100,
                order: this.order,
                search: this.filterText,
                sort: this.orderBy,
                start: 0,
                siteId: this.siteId
            });
        });
        this.handleBack = () => {
            this.cycleCountSelected = null;
        };
        this.onCallback = (value) => {
            this.filterText = value;
            this.loadPurchaseCycleCounts();
        };
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadPurchaseCycleCounts();
        };
        this.handleChangeSite = async (id) => {
            this.siteId = Number(id);
            this.loadPurchaseCycleCounts();
        };
        this.renderListRow = (row, index) => {
            const { user: { firstName = "", lastName = "" }, site: { displayName = "" }, createdAt } = row;
            const siteName = displayName;
            const userName = `${firstName} ${lastName}`;
            return (React.createElement(list_item_1.MaterialListItem, { key: index, onClick: this.handleCycleCountSelection(row) },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(siteName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(userName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: moment(createdAt).format("MM-DD-YYYY") })));
        };
        this.handleCycleCountSelection = (cycleCount) => () => {
            this.cycleCountSelected = cycleCount;
        };
        this.renderCycleCountSelected = () => (React.createElement(edit_cycle_count_history_detail_1.EditCycleCountHistoryDetail, { cycleCount: this.cycleCountSelected }));
        this.renderOrderHistoryList = () => this.cycleCountSelected ? (this.renderCycleCountSelected()) : (React.createElement("div", { className: "cycle-count-history-list" },
            React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: store_2.stocksStore.cycleCounts.value || [], renderRow: this.renderListRow, resizableheader: true, customClass: "custom-material-list__cycle-count-history-list" })));
    }
    get availableOptions() {
        return store_1.sitesListStore.sites.value
            ? store_1.sitesListStore.sites.value.map((site, i) => ({
                id: i,
                label: site.displayName || site.name,
                value: site.id.toString()
            }))
            : [];
    }
    async componentWillMount() {
        store_1.sitesListStore.loadSitesNoRelation(); // @tkay load sites no relations
        this.siteId =
            store_3.usersStore.user && store_3.usersStore.user.value && store_3.usersStore.user.value.siteId
                ? store_3.usersStore.user.value.siteId
                : 0;
        this.loadPurchaseCycleCounts();
    }
    render() {
        return (React.createElement("div", { className: "inventory-order__order-templates" },
            React.createElement(material_ui_1.Typography, { variant: "display1" }, "Cycle Count History"),
            !this.cycleCountSelected ? (React.createElement("div", { className: "order-templates__button" },
                React.createElement(select_1.MaterialSelect, { options: this.availableOptions, required: true, searchable: true, label: "Pharmacy", onSelect: this.handleChangeSite, value: String(this.siteId) || "" }))) : (React.createElement("div", { className: "order-templates__button" },
                React.createElement(button_1.MaterialButton, { onClick: this.handleBack }, "Back"))),
            !this.cycleCountSelected ? (React.createElement(filter_header_1.FilterHeader, { label: "Search", title: "Cycle Count History", callBack: this.onCallback, filterText: this.filterText })) : ([...this.renderHeader()]),
            this.renderOrderHistoryList()));
    }
    *renderHeader() {
        const { createdAt, user: { firstName, lastName }, site } = this.cycleCountSelected;
        yield (React.createElement("div", { className: "cycle-count", key: "qty-overview" },
            React.createElement("div", null,
                React.createElement(material_ui_1.Typography, { color: "inherit", variant: "display1" }, "Cycle Count")),
            React.createElement("div", { className: "cycle-count__user-site" },
                React.createElement(material_ui_1.Typography, { color: "inherit", variant: "subheading" },
                    "User: ",
                    `${firstName} ${lastName}`),
                React.createElement(material_ui_1.Typography, { color: "inherit", variant: "subheading" },
                    "Pharmacy: ",
                    site ? site.displayName || site.name : "Site not found"),
                React.createElement(material_ui_1.Typography, { color: "inherit", variant: "subheading" },
                    "Date: ",
                    moment(createdAt).format("MM-DD-YYYY")))));
    }
};
__decorate([
    mobx_1.computed
], EditCycleCountHistory.prototype, "availableOptions", null);
__decorate([
    mobx_1.observable
], EditCycleCountHistory.prototype, "cycleCounts", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountHistory.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountHistory.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountHistory.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountHistory.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountHistory.prototype, "cycleCountSelected", void 0);
__decorate([
    mobx_1.action
], EditCycleCountHistory.prototype, "onCallback", void 0);
__decorate([
    mobx_1.action
], EditCycleCountHistory.prototype, "handleChangeSite", void 0);
EditCycleCountHistory = __decorate([
    mobx_react_1.observer
], EditCycleCountHistory);
exports.EditCycleCountHistory = EditCycleCountHistory;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/stocks/modules/sites-detail/components/edit-cycle-count-history/edit-cycle-count-history.tsx
// module id = 4111
// module chunks = 0